import { Grid } from "@material-ui/core";
import React from "react";

import "./ProgrammeOverviewPreview.scss";
import { ProgrammeOverview } from "../../../types/ProgrammeOverview";
import ProgrammeStepPreview from "../../molecules/ProgrammeStepPreview/ProgrammeStepPreview";

interface Props {
  programmeSlug: string;
  programmeOverview: ProgrammeOverview;
}

const ProgrammeOverviewPreview: React.FC<Props> = ({
  programmeOverview,
  programmeSlug,
}: Props) => {
  return (
    <div className="programme-overview">
      <Grid container spacing={3}>
        <div className="programme-overview__navy"></div>
        <div className="programme-overview__green"></div>
        {programmeOverview.steps.length > 0 &&
          programmeOverview.steps.map((step, index) => {
            return (
              <Grid key={index} item xs={12} style={{ width: "100%" }}>
                <ProgrammeStepPreview
                  title={step.title}
                  stepNumber={step.stepNumber}
                  parts={step.parts}
                  programmeSlug={programmeSlug}
                />
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
};

export default ProgrammeOverviewPreview;
